module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Latest Events","title1":"Browse All Events","msg0":"No events available "},"ar":{"page-title":"آخر فعاليات سوق دبي المالي","title1":"جميع فعاليات سوق دبي المالي","msg0":"لا توجد أحداث متاحة"}}')
  delete Component.options._Ctor
}
